'use client';

import { useEffect } from 'react';

import {
  ADPOPCORN_SDK_EVENT_NAME,
  type AdpopcornSdkEventName,
  MESSAGE_KEYWORD,
  subscribeAppEvents,
} from '@/modules/wello-app';

interface AdpopcornSdkEventData {
  event: AdpopcornSdkEventName;
  payload: unknown;
}

interface UseAdpopcornSdkEventsOptions {
  onClosedOfferWallPage?: (payload: unknown) => void;
  onCompletedCampaign?: (payload: unknown) => void;
  onOfferwallTotalRewardInfo?: (payload: unknown) => void;
  onBridgeTotalRewardInfo?: (payload: unknown) => void;
}

export const useAdpopcornSdkEvents = ({
  onClosedOfferWallPage,
  onCompletedCampaign,
  onOfferwallTotalRewardInfo,
  onBridgeTotalRewardInfo,
}: UseAdpopcornSdkEventsOptions = {}) => {
  useEffect(() => {
    return subscribeAppEvents((msg) => {
      if (msg.type !== MESSAGE_KEYWORD.ADPOPCORN_SDK_EVENT) return;
      const data = msg.data as AdpopcornSdkEventData | undefined;
      if (!data) return;

      switch (data.event) {
        case ADPOPCORN_SDK_EVENT_NAME.CLOSED_OFFER_WALL_PAGE:
          onClosedOfferWallPage?.(data.payload);
          break;
        case ADPOPCORN_SDK_EVENT_NAME.COMPLETED_CAMPAIGN:
          onCompletedCampaign?.(data.payload);
          break;
        case ADPOPCORN_SDK_EVENT_NAME.OFFERWALL_TOTAL_REWARD_INFO:
          onOfferwallTotalRewardInfo?.(data.payload);
          break;
        case ADPOPCORN_SDK_EVENT_NAME.BRIDGE_TOTAL_REWARD_INFO:
          onBridgeTotalRewardInfo?.(data.payload);
          break;
      }
    });
  }, [
    onClosedOfferWallPage,
    onCompletedCampaign,
    onOfferwallTotalRewardInfo,
    onBridgeTotalRewardInfo,
  ]);
};
